import api from './api';

export const machineryConductorService = {
  async getConductors(params = {}) {
    const response = await api.get('/machinery/conductors', { params });
    return response.data;
  },

  async getConductor(id) {
    const response = await api.get(`/machinery/conductors/${id}`);
    return response.data;
  },

  async createConductor(data) {
    const response = await api.post('/machinery/conductors', data);
    return response.data;
  },

  async updateConductor(id, data) {
    const response = await api.put(`/machinery/conductors/${id}`, data);
    return response.data;
  },

  async deleteConductor(id) {
    const response = await api.delete(`/machinery/conductors/${id}`);
    return response.data;
  },
};
